@if (show() === 'all' || show() === 'brightness') {
  <div class="rec-fill__field" ssTooltip="Adjust how bright the screen fill light is">
    <span class="rec-fill__label">
      <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
        <circle cx="12" cy="12" r="5"/>
        <path d="M12 1v2M12 21v2M4.22 4.22l1.42 1.42M18.36 18.36l1.42 1.42M1 12h2M21 12h2M4.22 19.78l1.42-1.42M18.36 5.64l1.42-1.42"/>
      </svg>
      BRIGHTNESS
    </span>
    <rec-range-slider
      label="Brightness"
      trackVariant="brightness"
      [min]="0"
      [max]="100"
      [step]="1"
      [value]="brightness()"
      [style.--brightness-gradient]="brightnessGradient()"
      (change)="onBrightness($event)"
    />
  </div>
}

@if (show() === 'all' || show() === 'tones') {
  <div class="rec-fill__field" [ssTooltip]="'Tone — ' + tones[activeIndex()].tooltip">
    <span class="rec-fill__label">
      <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
        <path d="M14 4v10.54a4 4 0 1 1-4 0V4a2 2 0 0 1 4 0z"/>
      </svg>
      TONE
    </span>
    <div class="rec-fill__tone-marks">
      @for (t of tones; track t.name; let i = $index) {
        <button
          type="button"
          class="rec-fill__tone-mark"
          [class.is-active]="activeIndex() === i"
          (click)="applyTone(t.name)"
        >{{ t.label }}</button>
      }
    </div>
  </div>
}
